export default __webpack_public_path__ + "static/media/head.eca446b9.svg";